import { apiRequest, HttpMethod } from '@hqo/shared-modules/dist/api-request';
import { useMutation, UseMutateFunction } from '@tanstack/react-query';
import { useApi } from 'app/shared/contexts/api';
import { useUser } from 'app/shared/contexts/user';
import { TRACKING_APP } from 'app/shared/consts';
import { TrackEventBasePayload, TrackEventInputUnion } from 'app/data/types/tracking';

interface TrackEventResponse {
  message: string;
  statusCode: number;
}

interface UseTrackEventMutation {
  trackEvent: UseMutateFunction<void, Error, TrackEventInputUnion>;
}

/**
 * Fire-and-forget POST to the tracking ingest. Deliberately `mutate` rather than `mutateAsync`: a
 * failed beacon must never reject into the click handler that emitted it.
 */
export const useTrackEventMutation = (): UseTrackEventMutation => {
  const { apiUrl, getAuthHeaders } = useApi();
  const { user } = useUser();

  const { mutate: trackEvent } = useMutation<void, Error, TrackEventInputUnion>({
    mutationFn: async (input: TrackEventInputUnion) => {
      const body: TrackEventBasePayload = {
        app: TRACKING_APP,
        timestamp: Date.now(),
        user_agent: navigator.userAgent,
        user_uuid: user?.uuid ?? '',
        ...input,
      };

      await apiRequest<TrackEventResponse, TrackEventBasePayload, undefined>({
        url: `${apiUrl}/tracking/track/v2`,
        method: HttpMethod.POST,
        headers: await getAuthHeaders(),
        body,
      });
    },
  });

  return { trackEvent };
};
